import { render, staticRenderFns } from "./xiaofu.vue?vue&type=template&id=b380e8c8&scoped=true"
import script from "./xiaofu.vue?vue&type=script&lang=js"
export * from "./xiaofu.vue?vue&type=script&lang=js"
import style0 from "./xiaofu.vue?vue&type=style&index=0&id=b380e8c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b380e8c8",
  null
  
)

export default component.exports